"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.professionalUserChange = exports.EProfessionalUserType = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
let EProfessionalUserType = exports.EProfessionalUserType = /*#__PURE__*/function (EProfessionalUserType) {
  EProfessionalUserType["change"] = "registration/professionalUser/change";
  return EProfessionalUserType;
}({});
const professionalUserChange = exports.professionalUserChange = (0, _actionGenerator.actionGenerator)(EProfessionalUserType.change);